import type { PuzzleManifestEntry } from './dailyPuzzle';
import type { Key9Puzzle } from '../types/puzzle';

export type DailyPuzzleIdentity = {
  dailyDate: string;
  puzzleId: string;
  puzzleDate: string;
  puzzlePath: string;
  puzzleHash: string;
};

export function createDailyPuzzleIdentity(input: {
  dailyDate: string;
  puzzle: Key9Puzzle;
  manifestEntry?: PuzzleManifestEntry | null;
  puzzlePath?: string | null;
}): DailyPuzzleIdentity {
  return {
    dailyDate: input.dailyDate,
    puzzleId: input.manifestEntry?.id ?? input.puzzle.id,
    puzzleDate: input.manifestEntry?.date ?? input.puzzle.date,
    puzzlePath: input.manifestEntry?.path ?? input.puzzlePath ?? `/puzzles/${input.puzzle.date.slice(0, 4)}/${input.puzzle.date}.json`,
    puzzleHash: hashPuzzleContent(input.puzzle)
  };
}

export function getDailyProgressStorageKey(identity: DailyPuzzleIdentity): string {
  return `daily:${identity.dailyDate}:${identity.puzzleHash}`;
}

export function isSameDailyPuzzleIdentity(
  a: DailyPuzzleIdentity | null | undefined,
  b: DailyPuzzleIdentity | null | undefined
): boolean {
  return !!a
    && !!b
    && a.dailyDate === b.dailyDate
    && a.puzzleId === b.puzzleId
    && a.puzzleDate === b.puzzleDate
    && a.puzzlePath === b.puzzlePath
    && a.puzzleHash === b.puzzleHash;
}

export function hashPuzzleContent(puzzle: Pick<Key9Puzzle, 'puzzle' | 'solution' | 'keyCells'>): string {
  const source = JSON.stringify({
    puzzle: puzzle.puzzle,
    solution: puzzle.solution,
    keyCells: [...puzzle.keyCells]
  });
  return fnv1a(source).toString(36);
}

function fnv1a(value: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < value.length; i += 1) {
    hash ^= value.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}
